import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import {
  trajectoryDisplayLabel,
  trajectoryTrendNote,
  trajectoryChipColor,
  trajectoryChipRate,
  trajectoryTone,
} from '../constants/trajectory';

function TrajIcon({ dir, size = 14 }) {
  const tone = trajectoryTone(dir);
  if (tone === 'up') return <TrendingUp size={size} className="text-emerald-600 shrink-0" />;
  if (tone === 'down') return <TrendingDown size={size} className="text-red-500 shrink-0" />;
  return <Minus size={size} className="text-slate-400 shrink-0" />;
}

/**
 * Headline trajectory chip (recent direction) plus optional two-part note.
 * `trajectory` may be a direction string or the full object from get-farm-summary.
 */
export default function TrajectoryReadout({
  trajectory,
  compact = false,
  showNote = true,
  showRate = false,
  className = '',
  chipClassName = '',
}) {
  const label = trajectoryDisplayLabel(trajectory);
  if (!label) return null;

  const dir = trajectory;
  const note = trajectoryTrendNote(trajectory);
  // Handoff 61: a published trend_note is the rate. The chip does not add "pts/yr".
  const rateText = showRate ? trajectoryChipRate(dir) : null;
  const color = trajectoryChipColor(dir);

  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 text-xs font-medium ${className}`}
        style={{ color }}
        title={note || undefined}
      >
        <TrajIcon dir={dir} size={11} />
        <span>{label}</span>
      </span>
    );
  }

  return (
    <div className={className}>
      <div className={`flex items-center gap-2 ${chipClassName}`}>
        <TrajIcon dir={dir} />
        <span className="font-semibold" style={{ color }}>{label}</span>
        {rateText ? (
          <span className="text-xs text-slate-500">({rateText})</span>
        ) : null}
      </div>
      {showNote && note && (
        <p className="text-xs text-slate-600 leading-relaxed mt-1.5">{note}</p>
      )}
    </div>
  );
}

export { TrajIcon, trajectoryDisplayLabel };
